import React from "react";

export type IconComponent = React.ComponentType<{
  variant: "regular" | "filled" | "thin";
  color?: string;
}>;

export type DeprecatedIcon =
  | "back"
  | "remove"
  | "find"
  | "surveys"
  | "datepicker_nav"
  | "check"
  | "bell"
  | "open_caret"
  | "open_caret_left"
  | "open_caret_up"
  | "open_caret_down"
  | "company_links"
  | "birthday_cake"
  | "anniversary_cal"
  | "rating"
  | "high_five_hollow"
  | "up_arrow"
  | "down_arrow"
  | "filter_menu"
  | "link_feature"
  | "nomination"
  | "kazoo_logo";

export type IconDictionary =
  | "add_user"
  | "admin"
  | "ai_general"
  | "ai_scoring"
  | "ai_text"
  | "anniversary_cal"
  | "anniversary"
  | "arrow_up"
  | "arrow_right"
  | "arrow_down"
  | "arrow_left"
  | "attachment"
  | "back"
  | "bell"
  | "birthday_cake"
  | "birthday"
  | "calendar"
  | "caret_dn"
  | "caret_down"
  | "caret_left"
  | "caret_right"
  | "caret_up"
  | "check_in"
  | "check_seal"
  | "check"
  | "checkmark"
  | "clock"
  | "close"
  | "cloud_download"
  | "comment"
  | "company_links"
  | "copy"
  | "datepicker_nav"
  | "dot"
  | "down_arrow"
  | "download"
  | "drag"
  | "drag_indicator"
  | "earn"
  | "email"
  | "expired"
  | "eye"
  | "feedback"
  | "filter_menu"
  | "filter"
  | "find"
  | "flag"
  | "giphy"
  | "goal_count"
  | "goal_percent"
  | "goal_task"
  | "goals"
  | "hamburger"
  | "help"
  | "high_five_hollow"
  | "high_five"
  | "home"
  | "horizontal_line"
  | "hourglass"
  | "image_file"
  | "image"
  | "info"
  | "insights"
  | "kazoo_logo"
  | "link_arrow"
  | "link_feature"
  | "link"
  | "loading"
  | "lock"
  | "media_error"
  | "meatball_menu"
  | "microphone"
  | "nomination"
  | "notification"
  | "open_caret_down"
  | "open_caret_left"
  | "open_caret_up"
  | "open_caret"
  | "pause"
  | "pencil"
  | "people"
  | "pin"
  | "pinned_icon_award"
  | "pinned_icon_bright_idea"
  | "pinned_icon_bullseye"
  | "pinned_icon_champagne"
  | "pinned_icon_cheer"
  | "pinned_icon_crown"
  | "pinned_icon_diamond"
  | "pinned_icon_hole_in_one"
  | "pinned_icon_medal"
  | "pinned_icon_metrics"
  | "pinned_icon_pin"
  | "pinned_icon_rock_and_roll"
  | "pinned_icon_rocket"
  | "pinned_icon_strength"
  | "pinned_icon_teddy_bear"
  | "platform_logo"
  | "plus"
  | "private_eye"
  | "private_push_pin"
  | "progress_circle"
  | "push_pin"
  | "quotes_left"
  | "quotes_right"
  | "rating"
  | "recognition"
  | "remove"
  | "rewards"
  | "roadmap"
  | "search"
  | "send_recognition"
  | "share_link"
  | "sidebar_collapse"
  | "skill"
  | "smiley"
  | "survey"
  | "surveys"
  | "syncs"
  | "talent_review_insights"
  | "talent_review"
  | "task_completed"
  | "teams"
  | "text_bold"
  | "text_bulletlist"
  | "text_input"
  | "text_italic"
  | "text_numberlist"
  | "text_underline"
  | "thumbs_down"
  | "thumbs_up"
  | "toggle"
  | "translate"
  | "trash"
  | "trend_down"
  | "trend_up"
  | "undo"
  | "up_arrow"
  | "up_down_caret"
  | "verified_checkmark"
  | "vertical_line"
  | "warning_no_outline"
  | "warning";
